import React, { useState, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { InsertComment } from '@material-ui/icons';
import { SmallIconButton, Text } from 'library';
import { PostModel, CommentModel } from '../NewsfeedModels';
import client from 'shared/ApiClient';
import { consoleLogInDev } from 'shared/Utils';
import { track } from 'shared/Tracking';
import Comment from './Comment';
import AddComment from './AddComment';

const Comments = ({ post, defaultCommentsExpanded }: { post: PostModel; defaultCommentsExpanded?: boolean }) => {
    const [comments, setComments] = useState<CommentModel[]>([]);
    const [commentsExpanded, setCommentsExpanded] = useState(defaultCommentsExpanded || false);
    const [commentCount, setCommentCount] = useState(post.comment_count);

    const getComments = () => {
        client(`api/comment/?post_id=${post.id}&reverse=true`)
            .then((comments) => {
                setComments(comments);
                setCommentCount(comments.length);
            })
            .catch(consoleLogInDev);
    };

    useEffect(() => {
        if (defaultCommentsExpanded) {
            populateComments();
        }
    }, []);

    const populateComments = () => {
        if (commentCount > 0) getComments();
    };

    const toggleComments = () => {
        track('Posts: Comments Opened/Closed', {
            post,
            previousExpandedState: commentsExpanded,
            newExpandedState: !commentsExpanded,
        });
        if (!commentsExpanded) populateComments();
        setCommentsExpanded(!commentsExpanded);
    };

    return (
        <>
            <Grid alignItems="center" style={{ cursor: 'pointer' }} onClick={toggleComments}>
                <SmallIconButton onClick={toggleComments} icon={InsertComment} />
                <Text variant="body2">{`${commentCount} comment${commentCount !== 1 ? 's' : ''}`}</Text>
            </Grid>
            {commentsExpanded && (
                <>
                    <AddComment post={post} refresh={getComments} />
                    {comments.map((comment) => (
                        <Comment key={comment.id} comment={comment} refresh={getComments} />
                    ))}
                </>
            )}
        </>
    );
};

export default Comments;
